import { render, staticRenderFns } from "./CouponFormUpdate.vue?vue&type=template&id=1519b0d9&scoped=true&"
import script from "./CouponFormUpdate.vue?vue&type=script&lang=js&"
export * from "./CouponFormUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CouponFormUpdate.vue?vue&type=style&index=0&id=1519b0d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1519b0d9",
  null
  
)

export default component.exports